<template>
  <div class="categories justify-content-space-between">
    <router-link
      tag="a"
      class="category-card shadow-dark bg-white"
      :to="'/projects?category=' + category.id"
      @click.native="closeModal"
      v-for="category in $store.state.categories"
      :key="category.id"
    >
      <div class="icon icon-sm text-primary">
        <i :class="'fad fa-' + category.icon"></i>
      </div>
      <h6 class="font-weight-bold text-uppercase text-primary mb-0">
        {{ category.name }}
      </h6>
    </router-link>
  </div>
</template>
<script>
export default {
  name: "Categories",
  methods: {
    closeModal() {
      if (this.$store.state.showDonate) {
        this.$store.state.showDonate = false;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.categories {
  display: inline-flex;
  flex-wrap: wrap;
  gap: 12px;
  justify-content: space-around;
}
.category-card {
  text-align: center;
  display: inline-block;
  width: 100px;
  border-radius: 5px;
  padding: 15px;
}
// mobile
@media (max-width: 767px) {
  .modal-body {
    padding-top: 10px !important;
  }
  .categories {
    gap: 5px;
  }
  .category-card {
    width: auto;
    padding: 5px;
    h6 {
      letter-spacing: -0.1px;
      font-size: 12px;
      display: inline;
    }
  }
  div.icon {
    font-size: 12px;
    display: inline;
  }
}
</style>